import React from 'react';
import {ButtonPriority} from 'wix-ui-tpa';
import {classes} from './CheckoutButton.st.css';
import classnames from 'clsx';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {StatesButtonStates, ThreeDotsLoader, StatesButton} from 'wix-ui-tpa/cssVars';
import {SECURE_CHECKOUT_ID} from '../SecureCheckout/SecureCheckout';

export enum CheckoutButtonDataHook {
  button = 'CheckoutButtonDataHook.button',
  threeDotsLoader = 'CheckoutButtonDataHook.threeDotsLoader',
}

export interface CheckoutButtonProps {
  disabled?: boolean;
  priority?: ButtonPriority;
  text: string;
  isNavigationToCheckoutInProcess?: boolean;
  className?: string;
}

export function CheckoutButton({
  disabled,
  priority,
  text,
  isNavigationToCheckoutInProcess,
  className,
}: CheckoutButtonProps) {
  const accessibilityEnabled = useControllerProps().host.accessibilityEnabled;
  const {handleCheckoutButtonClick, handleCheckoutButtonHover} = useControllerProps().navigationStore;
  const {fixGoToCheckoutButtonHoverBackground} = useControllerProps().cartStore;

  return (
    <StatesButton
      aria-labelledby={SECURE_CHECKOUT_ID}
      priority={priority}
      className={classnames(
        fixGoToCheckoutButtonHoverBackground
          ? classes.customizableCheckoutButton
          : // istanbul ignore next
            classes.customizableCheckoutButtonOld,
        className
      )}
      data-hook={CheckoutButtonDataHook.button}
      data-wix-checkout-button={CheckoutButtonDataHook.button}
      disabled={disabled}
      state={isNavigationToCheckoutInProcess ? StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE}
      onClick={() => {
        return handleCheckoutButtonClick({accessibilityEnabled});
      }}
      onMouseEnter={() => {
        return handleCheckoutButtonHover();
      }}
      inProgressContent={
        <ThreeDotsLoader data-hook={CheckoutButtonDataHook.threeDotsLoader} className={classes.threeDotButton} />
      }
      idleContent={text}
      upgrade
    />
  );
}
